import { render, staticRenderFns } from "./OneBayWide.vue?vue&type=template&id=3573fbc1&scoped=true"
import script from "./OneBayWide.vue?vue&type=script&lang=js"
export * from "./OneBayWide.vue?vue&type=script&lang=js"
import style0 from "./OneBayWide.vue?vue&type=style&index=0&id=3573fbc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573fbc1",
  null
  
)

export default component.exports